'use strict';

// Add init function that is executed on every page/fragment render
mpro.addInitStatic(($container) => {

	const $B = mpro.get$B();

	const accessibilityConfig = {
		'animations_off': {},
		'invert_colors': {
			'related': 'black_white',
		},
		'black_white': {
			'related': 'invert_colors',
		},
		'underline_links': {},
		'underline_titles': {},
		'low_contrast': {
			'related': 'high_contrast',
		},
		'high_contrast': {
			'related': 'low_contrast',
		},
		'smaller_font': {
			'related': 'bigger_font',
			'target': 'html',
		},
		'bigger_font': {
			'related': 'smaller_font',
			'target': 'html',
		},
		'bright_cursor': {
			'related': 'dark_cursor',
			'target': 'html',
		},
		'dark_cursor': {
			'related': 'bright_cursor',
			'target': 'html',
		},
	}

	const raw_options = mpro.Cookies.get('accessibilityOptions');

	/** @type {string[]} */
	let accessibilityOptions = [];

	const getTarget = (option) => {
		if (accessibilityConfig[option] && accessibilityConfig[option].target && accessibilityConfig[option].target === 'html') {
			return $B.parent('html');
		}

		return $B;
	};

	if (raw_options && raw_options !== "undefined") {
		try {
			const parsed = JSON.parse(raw_options);
			if (Array.isArray(parsed)) {
			accessibilityOptions = parsed.map(String); // ensures all items are strings
			}
		} catch {
			// invalid JSON, fallback to empty array
			accessibilityOptions = [];
		}
	}

	if (accessibilityOptions.length) {
		accessibilityOptions.forEach((option) => {
			getTarget(option).attr(`data_${option}`, "");
			$(`[data-toggle=accessibility][id=${option}]`).prop('checked', true);
		});
	}

	$B.off('click.mp-accessibility').on('click.mp-accessibility', '[data-reset=accessibility]', function(e) {
		e.preventDefault();
		
		Object.keys(accessibilityConfig).forEach((option) => {
			getTarget(option).removeAttr(`data_${option}`);
			$(`[data-toggle=accessibility][id=${option}]`).prop('checked', false);
		});

		accessibilityOptions = [];
		mpro.Cookies.set('accessibilityOptions', JSON.stringify(accessibilityOptions), {});
	});

	$('[data-toggle=accessibility]').on('click', function (e) {
	
		const $this = $(this);
	
		if ($this.is(':checked')) {
			accessibilityOptions = accessibilityOptions.concat($this.prop('id'));
			getTarget($this.prop('id')).attr(`data_${$this.prop('id')}`, "");

			// Unselect related options
			const relatedOptions = accessibilityConfig[$this.prop('id')] && accessibilityConfig[$this.prop('id')].related ? [accessibilityConfig[$this.prop('id')].related] : [];

			if (relatedOptions.length) {
				relatedOptions.forEach(option => {
					accessibilityOptions = accessibilityOptions.filter(item => item !== option);
					getTarget(option).removeAttr(`data_${option}`);
					$('[data-toggle=accessibility][id=' + option + ']').prop('checked', false);
				});
			}
		}
		else {
			accessibilityOptions = accessibilityOptions.filter(item => item !== $this.prop('id'))
			getTarget($this.prop('id')).removeAttr(`data_${$this.prop('id')}`);
		}

		mpro.Cookies.set('accessibilityOptions', JSON.stringify(accessibilityOptions), {});

	});
});